import { AppComponent } from './app.component';
import { TimelineComponent } from './components/parcel-informations/timeline/timeline.component';
import { HeaderComponent } from './components/Shared/header/header.component';
import { FooterComponent } from './components/Shared/footer/footer.component';
import { ErrorPageComponent } from './components/Shared/error-page/error-page.component';
import { InfoStepComponent } from './components/parcel-informations/info-step/info-step.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material-module';
/*
* Necessaire pour la gestion des dates en français
*/
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ParcelInformationsComponent } from './components/parcel-informations/parcel-informations.component';
import { AlertComponent } from './components/Shared/alert/alert.component';
import { ButtonComponent } from './components/Shared/button/button.component';
import { HomeComponent } from './components/parcel-informations/delivery-choice/home/home.component';
import { PickupComponent } from './components/parcel-informations/delivery-choice/pickup/pickup.component';
import { PickupPointComponent } from './components/parcel-informations/delivery-choice/pickup/pickup-point/pickup-point.component';
import { OtherRefComponent } from './components/parcel-informations/other-ref/other-ref.component';
import { BlocEcoResponsableComponent } from './components/Shared/bloc-eco-responsable/bloc-eco-responsable.component';
import { BlocHelpComponent } from './components/Shared/bloc-help/bloc-help.component';
import { DeliveryDialogComponent } from './components/parcel-informations/delivery-choice/delivery-dialog/delivery-dialog.component';
import { PersonnalDataComponent } from './components/Shared/footer/personnal-data/personnal-data.component';
import { CguComponent } from './components/Shared/footer/cgu/cgu.component';
import { LegalMentionsComponent } from './components/Shared/footer/legal-mentions/legal-mentions.component';
import { CookiesManagementComponent } from './components/Shared/footer/cookies-management/cookies-management.component';
import { DeliveryBlocComponent } from './components/parcel-informations/delivery-bloc/delivery-bloc.component';
import { OpeningHoursComponent } from './components/Shared/opening-hours/opening-hours.component';
import { PersonnalInfosComponent } from './components/parcel-informations/delivery-choice/personnal-infos/personnal-infos.component';
import { ConfirmBlocComponent } from './components/Shared/confirm-bloc/confirm-bloc.component';
import { CtaButtonComponent } from './components/parcel-informations/cta-button/cta-button.component';
import { ClaimComponent } from './components/parcel-informations/claim/claim.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ClaimReferenceBlocComponent } from './components/parcel-informations/claim-reference-bloc/claim-reference-bloc.component';
import { PopinFooterComponent } from './components/Shared/popin-footer/popin-footer.component';
import { InterceptorService } from './services/interceptor.service';
import { ToasterComponent } from './components/Shared/toaster/toaster.component';
import { CoBrandingComponent } from './components/parcel-informations/co-branding/co-branding.component';
import { ValidateChoiceComponent } from './components/Shared/validate-choice/validate-choice.component';
import { HelpComponent } from './components/Shared/bloc-help/help/help.component';
import { OneHelpThemeComponent } from './components/Shared/bloc-help/help/one-help-theme/one-help-theme.component';
import { DeliveryMapComponent } from './components/parcel-informations/timeline/delivery-map/delivery-map.component';
import { QrcodeComponent } from './components/Shared/qrcode/qrcode.component';
import { QrcodeDialogComponent } from './components/Shared/qrcode/qrcode-dialog/qrcode-dialog.component';
import { BlocCommercialComponent } from './components/Shared/bloc-commercial/bloc-commercial.component';
import { CartographieMapboxComponent } from './components/Shared/cartographie-mapbox/cartographie-mapbox.component';
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + new Date().getTime());
}

@NgModule({
  declarations: [
    AppComponent,
    TimelineComponent,
    HeaderComponent,
    FooterComponent,
    InfoStepComponent,
    ErrorPageComponent,
    ParcelInformationsComponent,
    AlertComponent,
    ButtonComponent,
    HomeComponent,
    PickupComponent,
    PickupPointComponent,
    OtherRefComponent,
    BlocEcoResponsableComponent,
    BlocHelpComponent,
    DeliveryDialogComponent,
    PersonnalDataComponent,
    CguComponent,
    LegalMentionsComponent,
    CookiesManagementComponent,
    DeliveryBlocComponent,
    OpeningHoursComponent,
    PersonnalInfosComponent,
    ConfirmBlocComponent,
    CtaButtonComponent,
    ClaimComponent,
    ClaimReferenceBlocComponent,
    PopinFooterComponent,
    ToasterComponent,
    CoBrandingComponent,
    ValidateChoiceComponent,
    HelpComponent,
    OneHelpThemeComponent,
    DeliveryMapComponent,
    QrcodeComponent,
    QrcodeDialogComponent,
    BlocCommercialComponent,
    CartographieMapboxComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    MaterialModule,
    ],
  providers: [
    DatePipe,
    //pour pouvoir centrer les popins
      {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true, direction: 'ltr'}},
      { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    ParcelInformationsComponent,

  ],
  exports: [
    TranslateModule
  ],
  bootstrap: [AppComponent],
  entryComponents:[DeliveryDialogComponent, HomeComponent, PickupComponent, ClaimComponent, ToasterComponent]
})
export class AppModule { }
